import { render, staticRenderFns } from "./NotificationCenterMedia.vue?vue&type=template&id=20f63e8a&scoped=true&"
import script from "./NotificationCenterMedia.vue?vue&type=script&lang=ts&"
export * from "./NotificationCenterMedia.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCenterMedia.vue?vue&type=style&index=0&id=20f63e8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f63e8a",
  null
  
)

export default component.exports